if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    if (window.location.pathname.includes("/products")) {
        const targetNode = document.querySelector(".js-product-form-submit-btn");

        if (targetNode) {
            const config = {
                attributes: true,  
                childList: true,       
                subtree: true,         
                characterData: true    
            };

            const callback = (mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "attributes" && mutation.attributeName === "disabled") {
                        const productForm = document.querySelector("[bss-b2b-main-product-form]");
                        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
    }

    document.addEventListener("DOMContentLoaded", () => {
        const inputSearch = document.querySelector(`#predictiveSearch_Input`);
        if (!inputSearch) return;

        let debounceTimer;
        inputSearch.addEventListener("input", (e) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
            window.dispatchEvent(new Event('scroll'));
            }, 300);
        });
    });

}

